import ApiClient from '@/api/ApiClient';
import { clone } from 'lodash-es';

const client = new ApiClient('tempworker/availability');

class AvailabilityApiTempWorker {

	static get () {
		return client.get<IAvailabilityModel>('');
	}

	static add (addAvailabilityModel: IAddAvailabilityModel) {
		return client.post<number>('', addAvailabilityModel);
	}

	static updateIsAvailable (id: number, isAvailable: boolean) {
		return client.put<void>(`${id}/isAvailable?isAvailable=${isAvailable}`);
	}

	static updateSchedule (updateScheduleModel: IUpdateAvailabilityScheduleModel) {
		const clonedUpdateSchedule = clone(updateScheduleModel);
		return client.put<void>(`${updateScheduleModel.id}/schedule`, clonedUpdateSchedule);
	}
}

export default AvailabilityApiTempWorker;
